import { render } from "./WorldEconRev.vue?vue&type=template&id=1b7403ee&ts=true"
import script from "./WorldEconRev.vue?vue&type=script&lang=ts"
export * from "./WorldEconRev.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__